module.exports = __webpack_public_path__ + "img/company.e2511bb7.svg";